import { useWatch } from 'react-hook-form';
import { MapShapeStylePreview } from '../preview/MapShapeStylePreview.tsx';

/**
 * Anteprima dello stile della geometria per l'immagine in stampa. Legge dal
 * form i colori, lo spessore del bordo e le opacità di riempimento/bordo.
 */
export function MapPrintImageStylePreview() {
  const fillColor = useWatch({ name: 'fillColor' });
  const strokeColor = useWatch({ name: 'strokeColor' });
  const strokeWidth = useWatch({ name: 'strokeWidth' });
  const fillOpacity = useWatch({ name: 'fillOpacity' });
  const strokeOpacity = useWatch({ name: 'strokeOpacity' });

  return (
    <MapShapeStylePreview
      fillColor={fillColor}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
      fillOpacity={fillOpacity}
      strokeOpacity={strokeOpacity}
    />
  );
}
